<template>
    <div>
       <ProfileList/>
    </div>
</template>

<script>
import ProfileList from '@/components/menuadmin/profile/ProfileList.vue'
export default {
    name:'profile',
    components:{
        ProfileList,
    },
}
</script>